<div
  *ngIf="!closed"
  [ngClass]="classMap"
  #wrapperElement
  [@tagAnimation]
  (@tagAnimation.done)="afterAnimation($event)"
  (click)="updateCheckedStatus()">
  <ng-content></ng-content>
  <i class="anticon anticon-cross" *ngIf="dwMode==='closeable'" (click)="closeTag($event)"></i>
</div>